




































import { Component, Prop, Vue } from 'vue-property-decorator';
import Chapter from '../../interfaces/models/Chapter';
import Flow from '../../interfaces/models/Flow';
import CleanInputVue from '../core/inputs/CleanInput.vue';

type MenuItem = { icon: string; text: string; action: string };

@Component({
  components: {
    cleanInput: CleanInputVue
  }
})
export default class PresentationMeta extends Vue {
  @Prop({ default: () => null, required: true }) item!: Flow | Chapter;
  @Prop({ default: (e: string) => null, required: true }) updateNameFn!: (name: string) => void;

  showMenu = false;
  menu: MenuItem[] = [
    { icon: 'mdi-pdf-box', text: 'To PDF', action: 'pdf' },
    { icon: 'mdi-trash-can', text: 'Delete', action: 'remove' },
    { icon: 'mdi-sitemap', text: 'Sitemap', action: 'sitemap' }
  ];
}
